import { Container, Box } from '@mui/material';
import React from 'react';

// ==============================|| FOOTER - CUSTOMIZED ||============================== //

const Footer = () => {
  return (
    <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '64px' }}>
      <Box sx={{ textAlign: 'center' }}>
     ©️ 2024 OpenAI-Global™️ Powered by Quantumore®️
      </Box>
    </Container>
  );
};

export default Footer;
